import { getSysDictionaryByKey, getSysParamsByKey } from '@/api/sysParams'

// 系统参数与字典
const state = {
  grade: [], // 年级
  stuStatus: [], // 学籍状态
  teacherType: [],
  majorType: [],
  lengthOfSchoolingType: [], // 学制
  weekList: '日一二三四五六日',
  // 电费支付方式
  payMethodMap: {
    wx: { label: '移动支付：微信', value: 'wx' },
    ccb: { label: '移动支付：建行', value: 'ccb' }
  },
  studentColumns: [
    { prop: 'examineNo', label: '录取编号', width: '120', align: 'center' },
    { prop: 'stuNo', label: '学号', width: '120', align: 'center' },
    { prop: 'grade', label: '年级', width: '80', align: 'center' },
    { prop: 'stuName', label: '姓名', width: '170' },
    { prop: 'originalMajorName', label: '录取专业', width: '150' },
    { prop: 'stuStatus', label: '学籍状态', width: '120' },
    { prop: 'sexType', label: '性别', width: '80', align: 'center' },
    { prop: 'collegeName', label: '院系', width: '150' },
    { prop: 'majorName', label: '就读专业', width: '150' },
    { prop: 'className', label: '班级', width: '170' },
    { prop: 'campusName', label: '校区名称', width: '100' },
    { prop: 'roomName', label: '宿舍', width: '200' },
    { prop: 'headshot', label: '门禁照片', width: '60', align: 'center' },
    { prop: 'payPassFlag', label: '免缴费登录', width: '130', align: 'center' },
    { prop: 'birthday', label: '生日', width: '130' },
    { prop: 'nation', label: '民族', width: '80', align: 'center' },
    { prop: 'political', label: '政治面貌', width: '130', align: 'center' },
    { prop: 'admissionStage', label: '录取阶段', width: '130' },
    { prop: 'admissionBatch', label: '录取批次名称', width: '130' },
    { prop: 'categoryName', label: '计划类别名称', width: '130' },
    { prop: 'admissionCategory', label: '录取类别', width: '130' },
    { prop: 'admissionMark', label: '录取总分', width: '130', align: 'center' },
    { prop: 'examineCode', label: '考生号', width: '130', align: 'center' },
    { prop: 'examineCodeNo', label: '考生代码', width: '130', align: 'center' },
    { prop: 'origin', label: '生源地', width: '130', align: 'center' },
    { prop: 'subjectKind', label: '科类名称', width: '130' },
    { prop: 'middleSchool', label: '中学名称', width: '130' },
    { prop: 'fixedPhone', label: '电话', width: '130' },
    { prop: 'linkMan', label: '联系人', width: '130' },
    { prop: 'linkManPhone', label: '联系人电话', width: '130', align: 'center' },
    { prop: 'phoneNumber', label: '联通号码(迎新)', width: '160', align: 'center' },
    { prop: 'fatherName', label: '父亲姓名', width: '130' },
    { prop: 'fatherPhone', label: '父亲电话', width: '130' },
    { prop: 'motherName', label: '母亲姓名', width: '130' },
    { prop: 'motherPhone', label: '母亲电话', width: '130' },
    { prop: 'postCode', label: '邮政编码', width: '130' },
    { prop: 'addressee', label: '收件人', width: '130' },
    { prop: 'province', label: '省', width: '130' },
    { prop: 'city', label: '市', width: '130' },
    { prop: 'region', label: '区', width: '130' },
    { prop: 'addressDetails', label: '详细地址', width: '130' },
    { prop: 'stuCategory', label: '学生类别', width: '130' },
    { prop: 'graduateCategory', label: '毕业类别', width: '130' },
    // { prop: 'stuStatus', label: '学籍状态', width: '130' },
    { prop: 'signIn', label: '学生是否已报到', width: '130' },
    { prop: 'clothesFlag', label: '是否已经领了校服', width: '130' },
    { prop: 'campusCardFlag', label: '是否已经领了校园卡', width: '130' },
    { prop: 'height', label: '身高', width: '130' },
    { prop: 'weight', label: '体重', width: '130' },
    { prop: 'shoeSize', label: '鞋码', width: '130' },
    { prop: 'coatSize', label: '上衣尺码', width: '130' },
    { prop: 'pantSize', label: '裤子尺码', width: '130' },
    { prop: 'bachelorIntentionSchool', label: '专升本意向学校', width: '130' },
    { prop: 'bachelorIntentionMajor', label: '专升本意向专业', width: '130' },
    { prop: 'idNumber', label: '身份证号', width: '130' },
    { prop: 'dormitoryBedNo', label: '宿舍床号', width: '130' },
    { prop: 'floorNum', label: '层数', width: '130' },
    { prop: 'dormitoryName', label: '宿舍栋名', width: '130' },
    // { prop: 'broadbandAccount', label: '宽带账号', width: '130' },
    { prop: 'remarks', label: '备注', minWidth: '160' }
  ],
  // 自定义导出学生的字段 list 选择
  exportStuKeys: {
    stuName: '姓名',
    stuNo: '学号',
    sexType: '性别',
    birthday: '生日',
    nation: '民族',
    political: '政治面貌',
    admissionStage: '录取阶段',
    admissionBatch: '录取批次名称',
    categoryName: '计划类别名称',
    admissionCategory: '录取类别',
    admissionMark: '录取总分',
    examineNo: '录取编号',
    examineCode: '考生号',
    examineCodeNo: '考生代码',
    origin: '生源地',
    subjectKind: '科类名称',
    middleSchool: '中学名称',
    fixedPhone: '电话',
    linkMan: '联系人',
    linkManPhone: '联系人电话',
    fatherName: '父亲姓名',
    fatherPhone: '父亲电话',
    motherName: '母亲姓名',
    motherPhone: '母亲电话',
    postCode: '邮政编码',
    addressee: '收件人',
    province: '省',
    city: '市',
    region: '区',
    addressDetails: '详细地址',
    stuCategory: '学生类别',
    graduateCategory: '毕业类别',
    stuStatus: '学籍状态',
    signIn: '学生是否已报到',
    clothesFlag: '是否已经领了校服',
    campusCardFlag: '是否已经领了校园卡',
    height: '身高',
    weight: '体重',
    shoeSize: '鞋码',
    coatSize: '上衣尺码',
    pantSize: '裤子尺码',
    bachelorIntentionSchool: '专升本意向学校',
    bachelorIntentionMajor: '专升本意向专业',
    idNumber: '身份证号',
    majorName: '专业名字',
    roomName: '宿舍号',
    className: '班级名',
    grade: '年级',
    collegeName: '院系名称',
    dormitoryBedNo: '宿舍床号',
    floorNum: '层数',
    dormitoryName: '宿舍栋名',
    broadbandAccount: '宽带账号',
    remarks: '备注'
  },
  userTypeMap: {
    2: {
      label: '学生',
      value: 2
    },
    3: {
      label: '教职工',
      value: 3,
      type: 'success'
    }
  },
  sexType: [{
    type: 1,
    name: '男'
  }, {
    type: 2,
    name: '女'
  }],
  sexTypeMap: {
    1: {
      value: 1,
      label: '男'
    },
    2: {
      value: 2,
      label: '女'
    }
  },
  yearItem: [{
    type: 1,
    name: '第一学年'
  }, {
    type: 2,
    name: '第二学年'
  }, {
    type: 3,
    name: '第三学年'
  }],
  payType: [{
    type: 1,
    name: '扣费'
  }, {
    type: 2,
    name: '现金'
  }, {
    type: 3,
    name: '刷卡'
  }, {
    type: 4,
    name: '汇款'
  }, {
    type: 5,
    name: '助贷'
  }, {
    type: 6,
    name: '减免'
  }, {
    type: 7,
    name: '退还'
  }, {
    type: 8,
    name: '移动支付'
  }, {
    type: 9,
    name: '移动支付:中行'
  }, {
    type: 10,
    name: '移动支付:工行'
  }, {
    type: 11,
    name: '其他'
  }],
  reviewStatus: [{
    paramValue: 1,
    paramName: '未审核',
    label: '审核中',
    btnType: 'primary'
  }, {
    paramValue: 2,
    paramName: '不通过',
    label: '不通过',
    btnType: 'danger'
  }, {
    paramValue: 3,
    paramName: '已审核',
    label: '已通过',
    btnType: 'success'
  }],
  greenRoadStatus: [{
    paramValue: 1,
    paramName: '贷款'
  }, {
    paramValue: 2,
    paramName: '分期'
  }, {
    paramValue: 3,
    paramName: '最低缴费'
  }, {
    paramValue: 4,
    paramName: '三次缴费'
  }],
  params: {} // 参数
}

const mutations = {
  // 设置年级
  setGradeList(state, data) {
    state.grade = data
  },
  // 设置学籍状态
  setStuStatus(state, data) {
    state.stuStatus = data
  },
  // 设置教师职务
  setTeacherType(state, data) {
    state.teacherType = data
  },
  setParams(state, data) {
    state.params = data
  },
  setMajorType(state, data) {
    state.majorType = data
  },
  setLengthOfSchoolingType(state, data) {
    state.lengthOfSchoolingType = data
  }
}

const actions = {
  // 获取系统字典
  getSystemDictionary({ commit }, params) {
    return new Promise((resolve, reject) => {
      getSysDictionaryByKey(params).then(res => {
        switch (params) {
          case 'grade':
            commit('setGradeList', res.data)
            break
          case 'stuStatus':
            commit('setStuStatus', res.data)
            break
          case 'teacherType':
            commit('setTeacherType', res.data)
            break
          case 'majorType':
            commit('setMajorType', res.data)
            break
          case 'lengthOfSchoolingType':
            commit('setLengthOfSchoolingType', res.data)
            break
        }
        resolve(res.data)
      }).catch(err => {
        reject(err)
      })
    })
  },
  // 获取系统字典
  getSystemParams({ commit }, params) {
    return new Promise((resolve, reject) => {
      getSysParamsByKey(params).then(res => {
        commit('setParams', res.data)
        resolve(res.data)
      }).catch(err => {
        reject(err)
      })
    })
  }
}

const getters = {}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}
